import { render, staticRenderFns } from "./AllPosts.vue?vue&type=template&id=808cc342&scoped=true&"
import script from "./AllPosts.vue?vue&type=script&lang=js&"
export * from "./AllPosts.vue?vue&type=script&lang=js&"
import style0 from "./AllPosts.vue?vue&type=style&index=0&id=808cc342&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808cc342",
  null
  
)

export default component.exports